// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { getObjectKeys, NullPartial, omitKeys, pickKeys, subsetTypeHasKey, ValueOf } from "@hex-insights/core";
import { AnnouncementCreateInput, AnnouncementDetailQuery, AnnouncementUpdateInput } from "../../../Utilities";
import { MediaAttachmentFormConversion } from "../MediaAttachment";
import { SharingPolicyFormConversion } from "../SharingPolicy";
import * as AnnouncementFormValues from "./form-values";

/**
 * Converts the given `formValues` for the create form to a GraphQL create input for the Announcement model.
 *
 * @param formValues The form values to convert.
 */
export function toGQLCreateInput<K extends keyof AnnouncementFormValues.Create = keyof AnnouncementFormValues.Create>(
	formValues: AnnouncementFormValues.CreateSubset<K>,
): AnnouncementCreateInput {
	const inputFormValues = omitKeys(formValues, ["mediaAttachments", "sharingPolicy"]);
	const input: NullPartial<AnnouncementCreateInput> = {
		...inputFormValues,
		mediaAttachments: subsetTypeHasKey(formValues, "mediaAttachments")
			? formValues.mediaAttachments.map((e) => MediaAttachmentFormConversion.toGQLCreateInAnnouncementInput(e))
			: undefined,
		sharingPolicy:
			subsetTypeHasKey(formValues, "sharingPolicy") && formValues.sharingPolicy.length > 0
				? SharingPolicyFormConversion.toGQLCreateInAnnouncementInput(formValues.sharingPolicy[0])
				: undefined,
	};
	return input as AnnouncementCreateInput;
}

/**
 * Converts the given `formValues` for the detail form to a GraphQL update input for the Announcement model.
 *
 * @param formValues The form values to convert. Generally only the changed form values.
 * @param initialFormValues The initial values of the form.
 */
export function toGQLUpdateInput<K extends keyof AnnouncementFormValues.Detail = keyof AnnouncementFormValues.Detail>(
	formValues: Partial<AnnouncementFormValues.DetailSubset<K>>,
	_initialFormValues?: AnnouncementFormValues.DetailSubset<K>,
): AnnouncementUpdateInput {
	const inputFormValues = omitKeys(formValues, ["authorID"]);
	const input: AnnouncementUpdateInput = { ...inputFormValues };

	if (subsetTypeHasKey(formValues, "endTime") && formValues.endTime === null) {
		input.clearEndTime = true;
	}

	return input;
}

export type AnnouncementFormKeyMap = {
	title: "title";
	body: "body";
	startTime: "startTime";
	endTime: "endTime";
	authorID: "author";
};

export type ToFormValuesArgs<K extends keyof AnnouncementFormValues.Detail = keyof AnnouncementFormValues.Detail> = {
	announcement: Pick<AnnouncementDetailQuery["announcement"], ValueOf<Pick<AnnouncementFormKeyMap, K>>>;
	fields?: { [Key in K]: true };
};

/**
 * Converts a Announcement instance to its corresponding detail form values.
 *
 * @param announcement The instance to convert.
 * @param fields The subset of fields to include.
 */
export function toFormValues<K extends keyof AnnouncementFormValues.Detail = keyof AnnouncementFormValues.Detail>({
	announcement,
	fields,
}: ToFormValuesArgs<K>): AnnouncementFormValues.DetailSubset<K> {
	const formValues = {
		title: subsetTypeHasKey(announcement, "title") ? announcement.title : "",
		body: subsetTypeHasKey(announcement, "body") ? announcement.body : "",
		startTime: subsetTypeHasKey(announcement, "startTime") ? announcement.startTime : null,
		endTime: subsetTypeHasKey(announcement, "endTime") ? announcement.endTime : null,
		authorID: subsetTypeHasKey(announcement, "author") ? announcement.author?.id ?? null : null,
	};
	return fields ? pickKeys(formValues, getObjectKeys(fields)) : formValues;
}
